import { useSearchUsers } from "@/api/admin/useSearchUsers";
import { useUpdateUserTestSettings } from "@/api/admin/useUpdateUserTestSettings";
import { ViewAsUserButton } from "@/components/ViewAs/ViewAsUserButton";
import { Button, Center, Loader, Stack, Switch, Table, Text, TextInput, Title } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useState } from "react";

export function AdminUsersPage() {
  const [searchInput, setSearchInput] = useState("");
  const [query, setQuery] = useState("");
  const { data, isLoading, isError } = useSearchUsers(query);
  const { mutateAsync: updateTestSettings, isPending } = useUpdateUserTestSettings();

  const handleSearch = () => {
    setQuery(searchInput.trim());
  };

  const handleTestPaymentChange = async (userId: string, testPaymentEnabled: boolean) => {
    try {
      await updateTestSettings({ userId, testPaymentEnabled });
      notifications.show({
        message: testPaymentEnabled
          ? "테스트 결제가 활성화되었습니다."
          : "운영 결제가 활성화되었습니다.",
        color: "green",
      });
    } catch (error) {
      notifications.show({
        message: error instanceof Error ? error.message : "테스트 결제 설정 변경에 실패했습니다.",
        color: "red",
      });
    }
  };

  return (
    <Stack p="md">
      <Title order={2}>사용자 결제 테스트 설정</Title>
      <Text c="dimmed">
        기본값은 운영 결제입니다. 테스트 결제를 활성화한 사용자만 테스트 채널을 사용합니다.
      </Text>
      <TextInput
        label="사용자 검색"
        placeholder="이메일, 이름 또는 닉네임"
        value={searchInput}
        onChange={(event) => setSearchInput(event.currentTarget.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") handleSearch();
        }}
      />
      <Button w="fit-content" onClick={handleSearch}>
        검색
      </Button>

      {isLoading && (
        <Center>
          <Loader />
        </Center>
      )}
      {isError && <Text c="red">사용자 목록을 불러오지 못했습니다.</Text>}
      {data && (
        <Table c="black">
          <Table.Thead>
            <Table.Tr>
              <Table.Th>이름</Table.Th>
              <Table.Th>이메일</Table.Th>
              <Table.Th>닉네임</Table.Th>
              <Table.Th>테스트 결제</Table.Th>
              <Table.Th>보기</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {data.users.map((user) => (
              <Table.Tr key={user.uid}>
                <Table.Td>{user.name ?? "-"}</Table.Td>
                <Table.Td>{user.email}</Table.Td>
                <Table.Td>{user.nickname ?? "-"}</Table.Td>
                <Table.Td>
                  <Switch
                    checked={user.testSettings.testPaymentEnabled}
                    disabled={isPending}
                    label={user.testSettings.testPaymentEnabled ? "테스트" : "운영"}
                    onChange={(event) =>
                      handleTestPaymentChange(user.uid, event.currentTarget.checked)
                    }
                  />
                </Table.Td>
                <Table.Td>
                  <ViewAsUserButton
                    userId={user.uid}
                    userName={user.name}
                    isTestUser={user.isTestUser}
                  />
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Stack>
  );
}
